export function initnav (permiso,retencion,usuario) {
    let items = [
        // {name: "Análisis", url: "/dashboard", icon: "fa fa-tachometer-alt"},
        {name: "Soporte - Series", url: "/emision/seriesSoporte", icon: "fa fa-file-invoice-dollar"},
        {title: true, name: "EMISION", class: "", wrapper: { element: "", attributes: {}}},
        {name: "Facturas", url: "/emision/factura", icon: "fa fa-file-invoice-dollar"},
        {name: "Boletas", url: "/emision/boleta", icon: "fa fa-file-invoice-dollar"},
        {name: "G. de Remisión", url: "/emision/guia", icon: "fa fa-file-invoice-dollar"},
        {name: "Proforma / OC / OP", url: "/emision/proforma", icon: "fa fa-file-invoice-dollar"},
        {name: "Percepción / Ret.", url: "/emision/percepcion", icon: "fa fa-file-invoice-dollar"},
        {name: "Market", url: "/emision/market", icon: "fa fa-file-invoice-dollar"},
        {name: "Caja", url: "/caja/Ordenpago", icon: "fas fa-cash-register"},
        {divider: true},
        {title: true, name: "GESTION", class: "", wrapper: {element: "", attributes: {}}},
        {name: "Productos", url: "/modulo/productos", icon: "fa fa-list-ul"},
        {name: "Reportes", url: "/reportes/generales", icon: "fa fa-chart-line"},
        {name: "Negocios", url: "/gestion/clientes", icon: "fa fa-users"},
        {name: "Cobranzas", url: "/gestion/cobranzas", icon: "fa fa-hand-holding-usd"},
        {name: "Pagos", url: "/gestion/pagos", icon: "fas fa-file-invoice-dollar"},
        {name: "Central Ventas", url: "/gestion/pedidos", icon: "fa fa-store"},
        {name: "Ingreso Stock", url: "/stock/stocks", icon: "fa fa-boxes"},
        {name: "Com. de Baja", url: "/emision/baja", icon: "fa fa-file-invoice-dollar"},
    ]
    let navegacion = []
    console.log(permiso, retencion)
    if(permiso=='0' && retencion =='0'){
        // console.log('no puede emitir percepciones ')
        if(usuario !='20601156530'){
            for(let i=0; i<items.length; i++){
                if(i!=6 && i!=0){
                    navegacion.push(items[i])
                }   
            }
        }else if(usuario == '20601156530'){
            for(let i=0; i<items.length; i++){
                if(i!=6){
                    navegacion.push(items[i])
                }  
            }
        }
      }else if(permiso=='1' || retencion =='1'){
        // console.log('puede emitir percepciones ')
        for(let i=0; i<items.length; i++){
            if(i!=0){
                navegacion.push(items[i])
            }  
        }
    }
    return navegacion
}

export function tasaicbper () {
    let anioBase = '2023'
    let anioActual = new Date().getFullYear()
    let tasaActual = 0.50
    let distanciaAnios = anioActual-anioBase
    if(distanciaAnios>0){
        tasaActual = tasaActual+(distanciaAnios/10)
    }
    return tasaActual
}
